import {createAction, props} from '@ngrx/store';
import { User } from "../../../modules/users/models/user";

export const setCurrent = createAction('[Usuário] Altera o usuário atual', props<{ payload: User }>())
